import { api } from '@/api'
import { Period } from '@/ui-kit'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export function useFetchUserSectors(
  period: Period
): UseQueryResult<Record<Period, { sector: string; jobs: string; points: string }[]>> {
  return useQuery({
    queryKey: ['useFetchUserDomains', period],
    queryFn: () => api.get(`/user/stats/sectors?period=${period}`),
    retry: 0
  })
}
